import React from 'react';
import { Heading } from '@fluid/typography-ui';
import { Callout } from '@fluid/callouts';
import { Section } from '@fluid/layouts';
import PropTypes from 'prop-types';
import ChromeLogo from '../media/images/chrome-7.svg';
import EdgeLogo from '../media/images/microsoft-edge-1.svg';
import FireFoxLogo from '../media/images/firefox-6.svg';
import SafariLogo from '../media/images/safari-3.svg';
import LoginLogo from './LoginLogo';
import { getLogoBackground } from '../utils/cssUtil';

const baseClsUnSupported = 'dbk-login-unsupported';
const SUPPORTED_BROWSERS = [
    {
        text: 'Chrome',
        logo: ChromeLogo,
    },
    {
        text: 'Edge',
        logo: EdgeLogo,
    },
    {
        text: 'FireFox',
        logo: FireFoxLogo,
    },
    {
        text: 'Safari',
        logo: SafariLogo,
    },
];
const LoginUnsupported = (props) => {
    const { baseCls, theme, loginConfig } = props;

    return (
        <Section
            contextCls={`${baseCls} ${baseCls}-unsupported`}
            indentContent={false}
        >
            <div style={getLogoBackground(loginConfig, theme)}>
                {' '}
                <LoginLogo theme={theme} contextCls={`${baseCls}__logo`} />
            </div>
            <Callout contextCls={baseClsUnSupported}>
                <div className="fluid-callout__text-container">
                    <div className="fluid-callout__title-container">
                        <Heading headingLvl={1}>Browser Not Supported</Heading>
                    </div>
                    <div className="fluid-callout__msg-container">
                        <p className="fluid-callout__msg">
                            Please switch to a supported browser and try again
                        </p>

                        <ul className={`${baseClsUnSupported}_logo_container`}>
                            {SUPPORTED_BROWSERS.map((supportedBrowser) => {
                                return (
                                    <li>
                                        <img
                                            className={`${baseClsUnSupported}_logo`}
                                            src={supportedBrowser.logo}
                                            alt={supportedBrowser.text}
                                        />
                                        <span className="dbk-login-unsupported_logo-text">
                                            {supportedBrowser.text}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </Callout>
        </Section>
    );
};

LoginUnsupported.defaultProps = {};

LoginUnsupported.propTypes = {
    baseCls: PropTypes.string,
    theme: PropTypes.object,
    loginConfig: PropTypes.object,
};

export default LoginUnsupported;
